import { Box } from '@mui/material';
import React from 'react';
import { MessageTemplatesList } from '../components/MessageTemplates/MessageTemplatesList';

export const MessageTemplatesAdmin: React.FC = () => (
    <Box sx={{ width: '100%' }}>
        <MessageTemplatesList />
    </Box>
);
